import Checkbox from '@material-ui/core/Checkbox';
import createStyles from '@material-ui/core/styles/createStyles';
import makeStyles from '@material-ui/core/styles/makeStyles';
import withStyles from '@material-ui/core/styles/withStyles';

import { colors } from '../../assets';
import { fontWeight } from '../../assets/theme/typography';

export const CheckboxStyled = withStyles(() =>
  createStyles({
    root: {
      '&.Mui-disabled': {
        '& rect': {
          stroke: colors.grey140,
        },
        '& path': {
          fill: colors.grey140,
        },
      },
      // Color classes using our own palette
      '&.color-primary': {
        color: colors.primary.main,
        '&.Mui-checked': {
          color: colors.primary.main,
        },
      },
      '&.color-secondary': {
        color: colors.secondary.main,
        '&.Mui-checked': {
          color: colors.secondary.main,
        },
      },
      '&.color-error': {
        color: colors.functionals.alert,
        '&.Mui-checked': {
          color: colors.functionals.alert,
        },
      },
      '&.color-success': {
        color: colors.functionals.success,
        '&.Mui-checked': {
          color: colors.functionals.success,
        },
      },
      '&.color-warning': {
        color: colors.functionals.warning,
        '&.Mui-checked': {
          color: colors.functionals.warning,
        },
      },
    },
  }),
)(Checkbox);

export const useStyles = makeStyles(
  createStyles({
    label: {
      '& .MuiFormControlLabel-label': {
        color: colors.basic.black,
        fontWeight: fontWeight.bold,
      },
    },
    labelSmall: {
      '& .MuiFormControlLabel-label': {
        marginLeft: 0,
        fontSize: '14px',
      },
    },
  }),
);
